<template>
  <div class="card" v-if="leilao">
    <div
      @click="redirectLeilao()"
      class="card-body"
      style="padding: 0px 0px 0px 0px; text-align: left; font-family: 'Montserrat', sans-serif; text-transform: uppercase; margin: 0px 0px 0px 0px"
    >
      <div style="border-bottom: 2px solid gray; text-align: left; line-height: 5px" class="p-2">
        <img width="75px" height="45px" :src="getLeilaoPath()" style="top: 5px; left: 5px; position: absolute" />
        <div style="margin-top: 7px; margin-left: 80px; position: relative">
          <p style="font-size: 14px; font-weight: bold; word-wrap: break-word">#{{ leilao.id }} - {{ leilao.cidade }} - {{ leilao.estado }}</p>
          <p style="font-size: 14px; font-weight: bold; word-wrap: break-word">{{ getFormatedTitle(leilao.leilao_titulo) }}</p>
          <p style="font-size: 14px; font-weight: bold; word-wrap: break-word">Leilão ID {{ leilao.id }}</p>

          <br />
          <br />
        </div>
      </div>
    </div>

    <div class="card-footer clearfix" style="padding: 5px 5px 5px 5px">
      <button style="font-size: 12px; border-radius: 2px" type="submit" class="btn btn-default">
        <i class="fa-solid fa-user"></i>
        0
      </button>
      <button
        style="font-size: 12px; border-radius: 2px; margin-left: 5px"
        type="submit"
        class="btn btn-default"
        data-toggle="modal"
        data-target="#visualizar-habilitacoes"
      >
        <div v-if="leilao.habilitacoes">
          <i class="fa-solid fa-laptop"></i>
          {{ leilao.habilitacoes.length }}
        </div>
        <div v-else>
          <i class="fa-solid fa-laptop"></i>
          0
        </div>
      </button>
      <button
        style="font-size: 12px; border-radius: 2px; margin-left: 5px"
        type="submit"
        class="btn btn-default"
        data-toggle="modal"
        data-target="#visualizar-lances"
      >
        <div v-if="leilao.lances">
          <i class="fa-solid fa-hammer"></i>
          {{ leilao.lances.length }}
        </div>
        <div v-else>
          <i class="fa-solid fa-hammer"></i>
          0
        </div>
      </button>
      <button style="font-size: 12px; border-radius: 2px; margin-left: 5px" type="submit" class="btn btn-default">
        <i class="fa-regular fa-clock"></i>
      </button>
      <button style="font-size: 12px; border-radius: 2px; margin-left: 5px" type="submit" class="btn btn-default">
        <i class="fa-solid fa-right-to-bracket"></i>
        Entrar
      </button>
    </div>
  </div>
</template>

<script>
import wppController from "../../controller/wppController";
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import moment from "moment";
import currencyController from "../../controller/currencyController";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  mixins: [wppController, sweetAlert, Swal, currencyController],

  props: ["leilao", "index"],

  data() {
    return {
      container: {},
      nome: "",
      email: "",
      senha: "",
      tipo_usuario: "",
      isLoading: false,
      lote_selecionado: "",
      indice_lote: "",
      imagem_lote: "",
      venda_direta: "",
      texto_btn: "",
      fade: false,
    };
  },

  mounted() {
    if (this.leilao.lotes.length) {
      this.lote_selecionado = this.leilao.lotes[0];
      this.indice_lote = 0;

      this.buscarImagemLote();
      this.buscarUltimaPraca();

      console.log("Primeiro lote do leilão " + this.leilao.leilao_titulo + " = " + this.lote_selecionado.id);
      console.log(this.lote_selecionado);
    }

    console.log("Todos os lotes do leilão " + this.leilao.leilao_titulo);
    console.log(this.leilao.lotes);
  },

  methods: {
    getLeilaoPath() {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + this.leilao.path + "/" + this.leilao.arquivo;
    },

    getProximaData(leilao) {
      let data = undefined;

      if (leilao.datas) {
        for (let i = 0; i < leilao.datas.length; i++) {
          if (
            leilao.datas[i].leilao_data_encerrada == 0 &&
            leilao.datas[i].leilao_retirado == 0 &&
            leilao.datas[i].leilao_oculto == 0 &&
            leilao.datas[i].leilao_suspenso == 0 &&
            leilao.datas[i].leilao_encerrado == 0
          ) {
            data = leilao.datas[i];
          }
        }

        if (data) {
          return this.formatDate(data.leilao_data);
        }
      }
    },

    getFormatedComitente(leilao) {
      let texto = leilao.processo.processo_vara;

      if (leilao.processo.cidade) {
        texto = texto + " - " + leilao.processo.cidade.nome + " - " + leilao.processo.estado.sigla;
      }

      if (leilao.processo.estado) {
        texto = texto + " - " + leilao.processo.cidade.nome + " - " + leilao.processo.estado.sigla;
      }

      if (texto && texto.length > 30) {
        return texto.substring(0, 30) + "...";
      } else {
        return texto;
      }
    },

    redirectLeilao() {
      if (this.leilao.lotes && this.leilao.lotes.length > 1) {
        window.open("/leilao/" + this.leilao.id + "/lotes", "_self");
      } else {
        window.open("/lote/" + this.leilao.lotes[0].id, "_self");
      }
    },

    getUrlLeilao() {
      if (this.leilao.lotes && this.leilao.lotes.length > 1) {
        return "/leilao/" + this.leilao.id + "/lotes";
      } else {
        return "/lote/" + this.leilao.lotes[0].id;
      }
    },

    getFormatedTitle(title) {
      if (title && title.length > 28) {
        return title.substring(0, 28) + "...";
      } else {
        return title;
      }
    },

    proximoLote(indice) {
      console.log("Indice " + indice);
      console.log("Length " + this.leilao.lotes.length);

      if (indice < this.leilao.lotes.length && indice >= 0) {
        this.lote_selecionado = this.leilao.lotes[indice];
        this.indice_lote = indice;

        this.buscarImagemLote();
        this.buscarUltimaPraca();
      } else {
        this.showErrorMessageWithButton("Ops...", "Este é o último lote");
      }
    },

    buscarUltimaPraca() {
      if (this.lote_selecionado) {
        if (this.leilao.leilao_num_pracas >= 1 && this.leilao.leilao_1_realizado == 0) {
          this.venda_direta = this.leilao.leilao_2_modalidade == "venda";
          this.gerarTexto(this.leilao.leilao_1_data, this.leilao.leilao_1_modalidade);
        } else if (this.leilao.leilao_num_pracas >= 2 && this.leilao.leilao_2_realizado == 0) {
          this.venda_direta = this.leilao.leilao_2_modalidade == "venda";
          this.gerarTexto(this.leilao.leilao_2_data, this.leilao.leilao_2_modalidade);
        } else if (this.leilao.leilao_num_pracas >= 3 && this.leilao.leilao_3_realizado == 0) {
          this.venda_direta = this.leilao.leilao_3_modalidade == "venda";
          this.gerarTexto(this.leilao.leilao_3_data, this.leilao.leilao_3_modalidade);
        } else if (this.leilao.leilao_num_pracas >= 4 && this.leilao.leilao_4_realizado == 0) {
          this.venda_direta = this.leilao.leilao_4_modalidade == "venda";
          this.gerarTexto(this.leilao.leilao_4_data, this.leilao.leilao_4_modalidade);
        } else {
          //CASO NENHUMA PRAÇA TENHA SIDO REALIZADA AINDA
          this.gerarTexto(this.leilao.leilao_1_data, this.leilao.leilao_1_modalidade);
        }
      }

      console.log("Venda direta lote " + this.lote_selecionado.id + " ? " + this.venda_direta);
    },

    gerarTexto(data_proxima_praca, modalidade) {
      if (modalidade != "venda") {
        let data = this.formatDateNew(data_proxima_praca);

        if (data != "Invalid date") {
          let vencido = new Date() >= new Date(data_proxima_praca);

          if (vencido) {
            this.texto_btn = "Aberto para lances";
          } else {
            this.texto_btn = "Em breve";
          }
        }
      } else {
        this.texto_btn = "Venda direta";
      }
    },

    formatDateNew(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },

    buscarImagemLote() {
      this.imagem_lote = this.lote_selecionado.thumb;
    },

    getLeilaoPath() {
      return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + this.leilao.path + "/" + this.leilao.arquivo;
    },

    getImagePath() {
      if (this.imagem_lote) {
        return process.env.MIX_VUE_APP_LOGOS_ENDPOINT + "/" + this.imagem_lote.path + "/" + this.imagem_lote.img;
      } else {
        return "/images/logo.png";
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY - HH:mm");
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else if (!this.validateEmail()) {
        this.showErrorMessageWithButton("Ops...", "Digite um email válido!");
      } else if (this.senha == "") {
        this.showErrorMessageWithButton("Ops...", "A senha não pode ficar em branco!");
      } else {
        this.create();
      }
    },

    create() {
      this.isLoading = true;

      let data = {
        nome: this.nome,
        email: this.email,
        senha: this.senha,
        chave: this.generateKey(),
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/users/create`, data)
        .then((response) => {
          console.log("Usuário criado!");
          console.log(response);

          this.showSuccessMessage("Usuário criado!");

          window.location.reload();
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        return true;
      } else {
        return false;
      }
    },

    generateKey() {
      return Math.random().toString(36).slice(2);
    },
  },
};
</script>

<style scoped>
.ic:hover {
  transition-duration: 500ms;
  transform: scale(1.2);
  color: #696969;
}

h5 {
  font-size: 18px;
  color: #4a4949;
}

.swal-modal {
  color: green;
  background-color: rgba(63, 255, 106, 0.69);
  border: 3px solid white;
}

.swal-overlay {
  background-color: rgba(43, 165, 137, 0.45);
}

.im-logo {
  -o-object-fit: cover;
  object-fit: cover;
}

.arrow-pass:hover {
  opacity: 0.7;
}

.realizado {
  text-decoration: line-through;
}

.btn-yellow {
  background-color: #f7de5e;
  border-color: #f7de5e;
  color: white;
}

.back-yellow {
  background-color: #f7de5e;
  border-color: #f7de5e;
  color: #301904;
}

.back-brown {
  background-color: #301904;
  color: white;
}
</style>
